import { MODULE } from "./searchFilter.actionTypes";

export const getSearch = (state) => {
  return state.getIn([MODULE, "search"]);
};
